"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _experimentTypeUtils = require("../load/experimentTypeUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var baselineColumnHeadersPropTypes = _propTypes["default"].shape({
  assayGroupId: _propTypes["default"].string.isRequired,
  factorValue: _propTypes["default"].string.isRequired,
  factorValueOntologyTermId: _propTypes["default"].string,
  // Some factors don’t have an ontology term... yet
  assayGroupSummary: _propTypes["default"].shape({
    // Present when rows are genes
    replicates: _propTypes["default"].number.isRequired,
    properties: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      propertyName: _propTypes["default"].string.isRequired,
      testValue: _propTypes["default"].string.isRequired,
      contrastPropertyType: _propTypes["default"].oneOf(["FACTOR", "SAMPLE"]).isRequired
    })).isRequired
  })
});

var assayGroupPropTypes = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  assayAccessions: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  replicates: _propTypes["default"].number.isRequired
});

var differentialColumnHeadersPropTypes = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  arrayDesignAccession: _propTypes["default"].string,
  // Present in microarray experiments
  referenceAssayGroup: assayGroupPropTypes.isRequired,
  testAssayGroup: assayGroupPropTypes.isRequired,
  displayName: _propTypes["default"].string.isRequired,
  contrastSummary: _propTypes["default"].shape({
    properties: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      propertyName: _propTypes["default"].string.isRequired,
      testValue: _propTypes["default"].string.isRequired,
      contrastPropertyType: _propTypes["default"].oneOf(["FACTOR", "SAMPLE"]).isRequired,
      referenceValue: _propTypes["default"].string.isRequired
    })).isRequired,
    experimentDescription: _propTypes["default"].string.isRequired,
    contrastDescription: _propTypes["default"].string.isRequired,
    testReplicates: _propTypes["default"].number.isRequired,
    referenceReplicates: _propTypes["default"].number.isRequired
  }).isRequired,
  resources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].string.isRequired,
    uri: _propTypes["default"].string.isRequired
  })).isRequired
});

var baselineExperimentProfilesRowsPropTypes = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  // Experiment accession
  experimentType: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  // Human-friendly exp. name with slice
  expressions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number
  })).isRequired,
  uri: _propTypes["default"].string.isRequired
});

var baselineGeneProfilesRowsExpressionsPropTypes = _propTypes["default"].shape({
  value: _propTypes["default"].number,
  quartiles: _propTypes["default"].shape({
    min: _propTypes["default"].number.isRequired,
    lower: _propTypes["default"].number.isRequired,
    median: _propTypes["default"].number.isRequired,
    upper: _propTypes["default"].number.isRequired,
    max: _propTypes["default"].number.isRequired
  })
});

var baselineGeneProfilesRowsPropTypes = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  // Gene ID
  name: _propTypes["default"].string.isRequired,
  // Gene name
  expressions: _propTypes["default"].arrayOf(baselineGeneProfilesRowsExpressionsPropTypes).isRequired,
  uri: _propTypes["default"].string.isRequired
});

var baselineProfilesPropTypes = _propTypes["default"].shape({
  searchResultTotal: _propTypes["default"].string.isRequired,
  rows: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([baselineExperimentProfilesRowsPropTypes, baselineGeneProfilesRowsPropTypes]))
});

var differentialProfilesPropTypes = _propTypes["default"].shape({
  maxDownLevel: _propTypes["default"].number,
  maxUpLevel: _propTypes["default"].number,
  minDownLevel: _propTypes["default"].number,
  minUpLevel: _propTypes["default"].number,
  rows: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired,
    designElement: _propTypes["default"].string.isRequired,
    // Present but empty in RNA-seq differential exps
    expressions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      contrastName: _propTypes["default"].string.isRequired,
      color: _propTypes["default"].string,
      foldChange: _propTypes["default"].number,
      pValue: _propTypes["default"].number,
      tStat: _propTypes["default"].number
    })).isRequired
  })).isRequired,
  searchResultTotal: _propTypes["default"].number
});

var dataPropTypes = _propTypes["default"].shape({
  config: _propTypes["default"].shape({
    geneQuery: _propTypes["default"].string.isRequired,
    conditionQuery: _propTypes["default"].string.isRequired,
    species: _propTypes["default"].string.isRequired,
    genomeBrowsers: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
    columnType: _propTypes["default"].string.isRequired,
    disclaimer: _propTypes["default"].string.isRequired
  }).isRequired,
  columnHeaders: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([baselineColumnHeadersPropTypes, differentialColumnHeadersPropTypes])).isRequired,
  columnGroupings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    memberName: _propTypes["default"].string.isRequired,
    groups: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].string.isRequired,
      name: _propTypes["default"].string.isRequired,
      values: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
    }))
  })).isRequired,
  profiles: _propTypes["default"].oneOfType([baselineProfilesPropTypes, differentialProfilesPropTypes]).isRequired,
  anatomogramData: _propTypes["default"].shape({
    allSvgPathIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
    species: _propTypes["default"].string.isRequired
  }),
  coexpressions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    // Only present in baseline, single result
    geneName: _propTypes["default"].string.isRequired,
    geneId: _propTypes["default"].string.isRequired,
    jsonProfiles: baselineProfilesPropTypes
  })),
  experiment: _experimentTypeUtils.experimentPropTypes
});

var _default = dataPropTypes;
exports["default"] = _default;